export enum SendOptions {
  sendNow = "sendNow",
  sendLater = "sendLater",
}
